;(function (angular) {
   'use strict'

   angular.module('app').directive('asProductImageGallery', productImageGallery)

   function productImageGallery($window, $timeout, $rootScope, modalService) {
      return {
         restrict: 'A',
         link: imageGalleryLink,
      }

      function imageGalleryLink(scope) {
         let _flickityGallery
         let _easyzoomApiObj
         let _galleryNode
         let _thumbsNode
         const _loadedThumbUrls = new Set()
         const _loadedImageIndexes = new Set() // note: used only in "mobile mode"
         _loadedImageIndexes.add(0) // note: we could initialize the set with `[0]` to prevent the need for this, but that's not supported in ie11
         const _isMobileMode = $rootScope.viewportSm
         const _galleryState = {
            selectedThumbIndex: '0',
            selectedImageIndex: '0',
            initialLoaded: false,
            thumbsLoaded: false,
            loadingPackImage: true,
         }
         scope.galleryState = _galleryState

         //================================================================================

         scope.launchMobileProductZoom = function () {
            modalService.mobileProductZoom(scope.product, _galleryState.selectedImageIndex).result.catch(angular.noop)
         }

         //================================================================================

         function destroy() {
            _galleryState.initialLoaded = false
            _galleryState.thumbsLoaded = false

            if (_flickityGallery) {
               _flickityGallery.destroy()
            }
            if (_thumbsNode) {
               _thumbsNode.removeEventListener('mousedown', _thumbListener)
               _thumbsNode = undefined
            }
            if (_easyzoomApiObj) {
               _easyzoomApiObj.teardown()
            }
         }

         function initProductImages() {
            if (scope.images === undefined || scope.images.length === 0) {
               $timeout(function () {
                  _galleryState.initialLoaded = true
                  _galleryState.loadingPackImage = false
               })
               return
            }

            $window.imagesLoaded('#js-productGalleryWrap', function () {
               scope.$evalAsync(function (scope) {
                  if (scope.images.length > 1) {
                     initFlickityGallery()
                     if (!_isMobileMode) {
                        initThumbs()
                     }
                  }
                  if (!_isMobileMode) {
                     initEasyzoom()
                  }
                  _galleryState.initialLoaded = true
                  _galleryState.loadingPackImage = false
               })
            })

            if (scope.images.length > 1 && !_isMobileMode) {
               $window.imagesLoaded('#js-productDetailGalleryThumbs', function () {
                  scope.$evalAsync(function () {
                     _galleryState.thumbsLoaded = true
                  })
               })
            }
         }

         function flickityLazyLoadHandler() {
            _galleryState.loadingPackImage = false
            scope.$digest()
         }

         function flickityChangeHandler(index) {
            _galleryState.selectedImageIndex = index
            // If the image has not yet been loaded, show the loading indicator.
            if (!_loadedImageIndexes.has(index)) {
               _loadedImageIndexes.add(index)
               _galleryState.loadingPackImage = true
            }
            scope.$digest()
         }

         function initFlickityGallery() {
            _galleryNode = document.getElementById('js-productDetailGallery')
            if (!_isMobileMode) {
               _thumbsNode = document.getElementById('js-productDetailGalleryThumbs')
            }

            _flickityGallery = new $window.Flickity(_galleryNode, {
               // docs: https://flickity.metafizzy.co/options.html
               imagesLoaded: true,
               wrapAround: true,
               cellAlign: 'center',
               pageDots: false,
               lazyLoad: true,
               accessibility: false,
               dragThreshold: 6, // default is `3`
               // mobile-mode only
               draggable: _isMobileMode,
               prevNextButtons: _isMobileMode,
            })

            _flickityGallery.on('lazyLoad', flickityLazyLoadHandler)

            if (_isMobileMode) {
               _flickityGallery.on('change', flickityChangeHandler)
               _flickityGallery.on('staticClick', scope.launchMobileProductZoom)
            }
         }

         function selectThumb(index) {
            if (!_flickityGallery) {
               return
            }
            _flickityGallery.select(index, true, true)
            if (_galleryState.initialLoaded) {
               scope.$digest()
            }
         }

         function _thumbListener(event) {
            const clickedIndex = event.target.dataset.index
            const clickedThumbUrl = event.target.dataset.imageUrl

            if (
               clickedIndex === undefined ||
               clickedIndex === _galleryState.selectedThumbIndex ||
               _galleryState.loadingPackImage
            ) {
               return
            }

            _galleryState.selectedThumbIndex = clickedIndex

            if (!_loadedThumbUrls.has(clickedThumbUrl)) {
               _loadedThumbUrls.add(clickedThumbUrl)
               _galleryState.loadingPackImage = true
            }

            selectThumb(clickedIndex)
         }

         function initThumbs() {
            _galleryState.selectedThumbIndex = '0'
            _loadedThumbUrls.add(scope.images[0])
            selectThumb(_galleryState.selectedThumbIndex)

            if (_thumbsNode) {
               _thumbsNode.addEventListener('mousedown', _thumbListener)
            }
         }

         function initEasyzoom() {
            if (!jQuery('.js-easyzoomItem').easyZoom) {
               return
            }

            // Instantiate easyzoom instances
            const easyzoomInstances = jQuery('.js-easyzoomItem').easyZoom()
            // Set the API object (needed to later remove events and elements (via the `teardown` method))
            _easyzoomApiObj = easyzoomInstances.data('easyZoom')
         }

         function refresh() {
            destroy()
            initProductImages()
         }

         //================================================================================
         // Events & Watchers
         //================================================================================

         scope.$watch('images', refresh)

         scope.$on('$destroy', destroy)
      }
   }
})(angular)
